module.exports = __webpack_public_path__ + "img/individual-meter-water-meter-cold-sm.4d757c2f.svg";